import React from 'react'

/* global window */

/**
 * This plugin is used to display the translation keys instead of translation values
 * to quickly figure out where any specific text is defined by looking at UI.
 *
 * This plugin has a drawback that when enabled it may break some code that expects value to be returned.
 */
const XRay = {
    type: 'postProcessor',
    name: 'xray',
    process: function (value, key) {
        if (!window.__i18n_xrayPluginEnabled) return value

        let returnKey = true

        const keyVal = key[0]

        // Avoid altering url's as they may be required as such
        if (keyVal.indexOf('/') === 0) returnKey = false
        if (keyVal.indexOf('http') === 0) returnKey = false

        return returnKey ? <span title={keyVal} style={{ display: 'contents' }}>{value}</span> : value
    }
}

export default XRay
